import React from "react";
import { useLanguage } from "../../../contexts";
import "../Privacy/Privacy.scss";

const content = {
  es: {
    title: "Términos y Condiciones – Sustemia",
    updated: "Última actualización: 2026",
    sections: [
      {
        title: "1. Uso del Servicio",
        body: "Sustemia provee una plataforma de gestión ambiental para empresas.",
      },
      {
        title: "2. Cuenta de Usuario",
        body: "Los usuarios son responsables de sus credenciales de acceso y de la información proporcionada.",
      },
      {
        title: "3. Uso Aceptable",
        body: "La plataforma no debe utilizarse para actividades ilegales o no autorizadas.",
      },
      {
        title: "4. Propiedad de los Datos",
        body: "Todos los datos ingresados pertenecen al cliente. Sustemia actúa como proveedor de servicio.",
      },
      {
        title: "5. Responsabilidad",
        body: "Sustemia no es responsable del uso indebido de los datos por parte de los usuarios.",
      },
      {
        title: "6. Disponibilidad",
        body: "El servicio puede ser actualizado o modificado en cualquier momento.",
      },
      {
        title: "7. Terminación",
        body: "Las cuentas pueden ser suspendidas por incumplimiento de estos términos.",
      },
      {
        title: "8. Legislación Aplicable",
        body: "Las leyes aplicables dependen de la jurisdicción del usuario y de las regulaciones internacionales.",
      },
    ],
  },
  en: {
    title: "Terms & Conditions – Sustemia",
    updated: "Last updated: 2026",
    sections: [
      {
        title: "1. Service Use",
        body: "Sustemia provides an environmental management platform for companies.",
      },
      {
        title: "2. User Account",
        body: "Users are responsible for their account credentials and provided information.",
      },
      {
        title: "3. Acceptable Use",
        body: "The platform must not be used for illegal or unauthorized activities.",
      },
      {
        title: "4. Data Ownership",
        body: "All data entered belongs to the client. Sustemia acts as a service provider.",
      },
      {
        title: "5. Liability",
        body: "Sustemia is not responsible for misuse of data by users.",
      },
      {
        title: "6. Availability",
        body: "The service may be updated or modified at any time.",
      },
      {
        title: "7. Termination",
        body: "Accounts may be suspended for violations of these terms.",
      },
      {
        title: "8. Governing Law",
        body: "Applicable laws depend on the user's jurisdiction and international regulations.",
      },
    ],
  },
};

export function Terms() {
  const { language } = useLanguage();
  const lang = content[language] || content.es;

  return (
    <div className="legal-page">
      <div className="legal-page__card">
        <h1 className="legal-page__title">{lang.title}</h1>
        <p className="legal-page__updated">{lang.updated}</p>
        <div className="legal-page__sections">
          {lang.sections.map((section, i) => (
            <div key={i} className="legal-page__section">
              <h2 className="legal-page__section-title">{section.title}</h2>
              <p className="legal-page__section-body">{section.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
